import React, { useEffect } from 'react';
import { TextInput, useRecordContext } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';

// Shown only while the "Database access" box is ticked. Hidden inputs keep their last value in
// react-hook-form state (shouldUnregister is false), so the server decides what to do with them.
export const DbAccessFields = ({ mode }) => {
  const { setValue, getValues } = useFormContext();
  const hasDbAccess = useWatch({ name: 'has_db_access' });
  const username = useWatch({ name: 'username' });
  const record = useRecordContext();
  const storedName = (record && record.db_username) || '';

  useEffect(() => {
    if (hasDbAccess && mode === 'create' && !getValues('db_username') && username) {
      setValue('db_username', username.trim().toLowerCase(), { shouldDirty: true });
    }
  }, [hasDbAccess, username, mode, getValues, setValue]);

  if (!hasDbAccess) return null;
  return (
    <>
      <TextInput source="db_username" label="DB username" required
                 InputProps={{ readOnly: mode === 'edit' && !!storedName }}
                 helperText="lowercase letters, digits and underscores" />
      <TextInput source="db_password" label="DB password" required />
    </>
  );
};
